import styled from 'styled-components';

export const Wrapper = styled.span`
  display: inline-grid;
  place-items: center;
`;
